export default {
  brand: 'USFansSheet.help',
  language: 'Langue',

  'meta.title': 'USFans Spreadsheet 2026 — Trouvailles, QC, Avis et Guides d\u2019Achat',
  'meta.desc': 'Explorez la USFans Spreadsheet avec trouvailles, guides QC, avis, frais d\u2019expédition et sécurité. Mise à jour pour 2026.',
  'meta.articleTitle': 'Qu\u2019est-ce que la USFans Spreadsheet ? Guide Complet 2026',
  'meta.articleDesc': 'Découvrez la USFans Spreadsheet, son utilisation, ses catégories, le QC, l\u2019expédition et les conseils de sécurité.',

  'nav.home': 'Accueil',
  'nav.shop': 'Guide d’achat',
  'nav.spreadsheet': 'Feuille',
  'nav.categories': 'Catégories',
  'nav.guides': 'Guides',

  'hero.badge': 'Ressource indépendante · Mise à jour pour 2026',
  'hero.title': 'USFans Spreadsheet — Trouvez de Meilleurs Produits, QC et Guides d\u2019Achat',
  'hero.subtitle': 'Explorez la USFans Spreadsheet dans un seul centre organisé. Découvrez des trouvailles produits, des guides de catégories, des conseils QC, des infos d\u2019expédition et des ressources de sécurité avant d\u2019acheter.',
  'hero.ctaPrimary': 'USFans Spreadsheet',
  'hero.ctaSecondary': 'Acheter Maintenant',
  'hero.trust': 'Indépendant · Axé sur la sécurité · Multilingue',

  'categories.title': 'Parcourir les Catégories de Produits',
  'categories.subtitle': 'Accédez directement à n\u2019importe quelle catégorie sur la plateforme principale.',
  'categories.dropdownLabel': 'Choisissez une catégorie',
  'categories.viewAll': 'Voir toutes les catégories',

  'cat.shoes': 'Chaussures',
  'cat.hoodies': 'Hoodies / Sweats',
  'cat.tshirts': 'T-shirts',
  'cat.jackets': 'Vestes',
  'cat.pants': 'Pantalons / Shorts',
  'cat.headwear': 'Couvre-chefs',
  'cat.sets': 'Ensembles',
  'cat.underwear': 'Sous-vêtements',
  'cat.jersey': 'Maillot',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Sacs',
  'cat.belts': 'Ceintures',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Autres Articles',

  'what.title': 'Qu\u2019est-ce que la USFans Spreadsheet ?',
  'what.p1': 'La USFans Spreadsheet est une façon structurée d\u2019organiser les trouvailles produits, les liens, les catégories et les informations d\u2019achat en un seul endroit.',
  'what.p2': 'Au lieu de faire défiler des pages interminables, la feuille vous aide à comparer les options, vérifier les notes QC et comprendre les processus d\u2019expédition et d\u2019entrepôt avant de commander.',
  'what.p3': 'Elle est conçue comme un répertoire informatif — un raccourci de recherche pour quiconque souhaite explorer les produits plus efficacement.',
  'what.cta': 'Découvrez Comment Ça Marche',
  'what.finds.title': 'Trouvailles produits',
  'what.finds.desc': 'Parcourez des découvertes organisées dans chaque catégorie.',
  'what.qc.title': 'Photos QC',
  'what.qc.desc': 'Vérifiez les photos de contrôle qualité avant de confirmer.',
  'what.shipping.title': 'Expédition',
  'what.shipping.desc': 'Comprenez les routes, le poids et les coûts de consolidation.',
  'what.sellers.title': 'Vendeurs',
  'what.sellers.desc': 'Vérifiez les détails et la réputation des vendeurs avant d’acheter.',

  'guideCard.title': 'Le Guide Complet de la USFans Spreadsheet',
  'guideCard.summary': 'Tout ce que vous devez savoir sur la USFans Spreadsheet — ce que c\u2019est, comment l\u2019utiliser, les catégories, le QC, l\u2019expédition et la sécurité — dans un guide adapté aux débutants.',
  'guideCard.readTime': '8 min de lecture',
  'guideCard.cta': 'Lire le guide',

  'pillar.title': 'Derniers guides et avis',
  'pillar.subtitle': 'Des articles frais et détaillés sur la USFans Spreadsheet : avis, expédition, sécurité et plus.',
  'pillar.readMore': 'Lire l’article',

  'cat.label.review': 'Avis',
  'cat.label.shipping': 'Expédition',
  'cat.label.coupon': 'Coupon',
  'cat.label.warehouse': 'Entrepôt',
  'cat.label.safety': 'Sécurité',
  'cat.label.qc': 'Guide QC',
  'cat.label.guide': 'Guide',

  'faq.title': 'Questions Fréquentes',
  'faq.q1': 'Qu\u2019est-ce que la USFans Spreadsheet ?',
  'faq.a1': 'C\u2019est un répertoire informatif qui organise les trouvailles produits, les liens, les catégories et les notes d\u2019achat pour que vous puissiez faire des recherches avant d\u2019acheter.',
  'faq.q2': 'La USFans Spreadsheet est-elle sûre ?',
  'faq.a2': 'Une feuille est un répertoire d\u2019informations, pas une garantie. Vérifiez toujours les liens, les vendeurs et les détails sur la plateforme principale avant d\u2019acheter.',
  'faq.q3': 'Comment fonctionnent les frais d\u2019expédition ?',
  'faq.a3': 'L\u2019expédition dépend du poids, des dimensions, de la destination et de la route ou du niveau de service choisi. La consolidation peut aussi modifier le prix final.',
  'faq.q4': 'Où trouver des codes de réduction ?',
  'faq.a4': 'Les promotions sont publiées par la plateforme elle-même. Consultez les canaux officiels sur le site principal et vérifiez toujours les conditions et l\u2019expiration.',
  'faq.q5': 'USFans est-il légitime ?',
  'faq.a5': 'USFans est une vraie plateforme, mais nous recommandons toujours de vérifier indépendamment les vendeurs, les informations de paiement et les liens avant de commander.',

  'footer.disclaimer': 'USFansSheet.help est une ressource informative indépendante et n\u2019est pas affilié, soutenu ni exploité par USFans.',
  'footer.rights': 'Tous droits réservés.',
  'footer.about': 'À propos de ce site',

  'notFound.title': 'Page introuvable',
  'notFound.desc': 'La page que vous recherchez n’existe pas ou a été déplacée.',

  'article.backHome': 'Retour à l\u2019accueil',
  'article.notFound': 'Article introuvable',
  'article.updated': 'Dernière mise à jour',
  'article.readTime': 'Temps de lecture',
  'article.minRead': 'min de lecture',
  'article.title': 'Qu\u2019est-ce que la USFans Spreadsheet ? Guide Complet 2026',
  'article.quickAnswerTitle': 'Réponse Rapide',
  'article.quickAnswer': 'La USFans Spreadsheet est un répertoire informatif qui organise les trouvailles produits, les liens de catégories, les notes QC et les conseils d\u2019achat en un seul endroit structuré. Elle vous aide à faire des recherches avant d\u2019acheter — mais elle ne vend rien elle-même et ne garantit pas que chaque vendeur ou lien est sûr.',
  'article.tocTitle': 'Sur cette page',

  'article.s1Title': 'Qu\u2019est-ce que la USFans Spreadsheet ?',
  'article.s1Body': 'La USFans Spreadsheet est une façon centralisée de parcourir les trouvailles produits dans de nombreuses catégories, des chaussures et vêtements aux sacs et accessoires. Au lieu de fouiller dans des pages dispersées, vous pouvez voir des liens et notes organisés en une seule vue. C\u2019est un outil de recherche, pas une boutique — tous les achats se font sur la plateforme principale.',

  'article.s2Title': 'Comment Utiliser la USFans Spreadsheet',
  'article.s2Body': 'Commencez par choisir une catégorie qui vous intéresse, puis examinez les articles listés et les éventuelles notes QC ou d\u2019expédition. Comparez quelques options avant de passer au site principal. Prendre quelques minutes pour faire des recherches d\u2019abord mène généralement à une expérience d\u2019achat plus fluide.',

  'article.s3Title': 'Catégories de Produits Expliquées',
  'article.s3Body': 'La feuille couvre un large éventail de catégories, notamment les chaussures, hoodies et sweats, t-shirts, vestes, pantalons et shorts, couvre-chefs, ensembles, sous-vêtements, maillots, accessoires, sacs, ceintures, parfums et autres articles. Chaque catégorie regroupe des produits liés pour que vous puissiez parcourir plus efficacement.',

  'article.s4Title': 'QC et Contrôles Qualité',
  'article.s4Body': 'Le QC, ou contrôle qualité, est l\u2019étape où les produits sont inspectés avant l\u2019expédition. De nombreux acheteurs utilisent les photos QC pour vérifier des détails comme les coutures, la taille et la couleur. Si le QC est disponible pour un article, examinez attentivement ces photos avant de confirmer votre commande.',

  'article.s5Title': 'Bases de l\u2019Expédition et de l\u2019Entrepôt',
  'article.s5Body': 'Le coût d\u2019expédition dépend de facteurs comme le poids, les dimensions, la destination et le niveau de service choisi. Certaines commandes passent par un entrepôt où les articles peuvent être stockés, photographiés et consolidés en moins de colis — ce qui peut parfois réduire le coût total d\u2019expédition.',

  'article.s6Title': 'USFans est-il Sûr et Légitime ?',
  'article.s6Body': 'USFans est une vraie plateforme utilisée par de nombreux acheteurs, mais aucun répertoire ne peut garantir que chaque vendeur, produit ou lien est sûr. Vérifiez toujours les liens, la réputation du vendeur, les détails de paiement et les informations produit de façon indépendante avant d\u2019acheter.',

  'article.s7Title': 'Conseils pour Débutants',
  'article.s7Body': 'Si vous débutez, commencez par une petite commande, examinez les photos QC lorsqu\u2019elles sont disponibles et conservez un historique de votre commande et de vos échanges. Vérifiez soigneusement les conditions d\u2019expédition et de promotion. Faites d\u2019abord vos recherches, puis achetez en toute confiance.',

  'article.tableTitle': 'Comparaison Rapide : Rechercher vs. Acheter Directement',
  'article.tableHeaders': ['Facteur', 'Rechercher d\u2019abord', 'Acheter directement', 'Idéal pour'],
  'article.tableRows': [
    ['Coût', 'Gratuit à parcourir', 'Payer au paiement', 'Planification budgétaire'],
    ['Vitesse', 'Plus lent (vous vérifiez)', 'Plus rapide', 'Commandes urgentes'],
    ['QC', 'Vous pouvez voir les photos', 'Peut sauter les contrôles', 'Acheteurs axés qualité'],
    ['Confiance', 'Plus élevée après recherche', 'Dépend de l\u2019annonce', 'Débutants'],
  ],

  'article.faqTitle': 'Questions Fréquentes',
  'article.faq1q': 'Qu\u2019est-ce que la USFans Spreadsheet ?',
  'article.faq1a': 'C\u2019est un répertoire organisé de trouvailles produits, de liens de catégories, de notes QC et de conseils d\u2019achat qui vous aide à faire des recherches avant d\u2019acheter.',
  'article.faq2q': 'La USFans Spreadsheet est-elle gratuite ?',
  'article.faq2a': 'Parcourir le répertoire est gratuit. Vous ne payez que les articles que vous décidez d\u2019acheter sur la plateforme principale.',
  'article.faq3q': 'Comment trouver les photos QC ?',
  'article.faq3a': 'Les photos QC sont généralement disponibles pour les articles qui passent par un entrepôt. Consultez chaque annonce sur la plateforme principale pour voir les images d\u2019inspection disponibles.',
  'article.faq4q': 'Tous les liens de la feuille sont-ils sûrs ?',
  'article.faq4a': 'Pas nécessairement. La feuille est informative, alors vérifiez toujours les liens, les vendeurs et les détails de paiement de façon indépendante avant d\u2019acheter.',

  'article.relatedTitle': 'Guides Connexes',
  'article.related1': 'Retour à la page d\u2019accueil USFans Spreadsheet',
  'article.related2': 'Parcourir toutes les catégories de produits',
  'article.ctaTitle': 'Prêt à explorer ?',
  'article.ctaBody': 'Ouvrez la USFans Spreadsheet et commencez vos recherches de produits dès aujourd\u2019hui.',
  'article.cta': 'Explorer la USFans Spreadsheet',
};